export enum TextColor {
    Light = "light",
    Dark = "dark",
}
